(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-product__info-blocks"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'mpaz.camille.fitting.v1';
  const expiry = 180 * 24 * 60 * 60 * 1000;
  const measureKeys = ['bust','waist','hips'];
  function recommend(body,config) {
    const {sizes,bodyChart,measureKeys:activeKeys,camille}=config;
    const indices = measureKeys.map((key,j) => {
      if(!activeKeys.includes(key))return -1;
      const found=bodyChart.findIndex(row=>body[key]/2.54<=row[j]+0.02);
      return found<0?sizes.length:found;
    });
    const base=Math.max(...indices);
    const extra=Boolean((camille&&body.height>=177.8-0.02)||(activeKeys.includes('bust')&&body.fuller)||body.preference==='room');
    const raw=base+(extra?1:0),last=sizes.length-1;
    return {indices,base,chosen:Math.min(last,raw),beyond:raw>last,below:measureKeys.every((key,j)=>!activeKeys.includes(key)||body[key]/2.54<bodyChart[0][j]-2),extra};
  }
  if (customElements.get('mpaz-camille-fitting-room')) return;
  customElements.define('mpaz-camille-fitting-room', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-fit-config]').textContent);
      this.text = this.config.text;
      this.sizes=this.config.sizes;
      this.bodyChart=this.config.bodyChart;
      this.activeKeys=this.config.measureKeys;
      this.querySelector('.mfr-size-scale').style.setProperty('--mfr-size-count',this.sizes.length);
      this.querySelector('.mfr-bust-options').hidden=!this.activeKeys.includes('bust');
      this.querySelectorAll('[data-fit-compare]').forEach((button,i)=>{button.hidden=i>=this.sizes.length;if(i<this.sizes.length)button.textContent=this.sizes[i];});
      this.sizeIndex = this.config.optionNames.findIndex(n => /^sizes?$/i.test(n));
      this.colorIndex = this.config.optionNames.findIndex(n => /colou?r/i.test(n));
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-fit-form]');
      this.unit = 'in';
      this.step = 0;
      this.activeTab = 'finder';
      this.abort = new AbortController();
      this.on(document,'click',e => {
        const trigger = e.target.closest('[data-camille-fit]');
        if (!trigger || trigger.dataset.camilleFit !== this.id) return;
        e.preventDefault();
        this.opener = trigger;
        this.open();
      });
      this.on(this,'click',e => this.handleClick(e));
      this.on(this,'change',e => {
        e.stopPropagation();
        if(e.target.name === 'units') this.convertUnits(e.target.value);
        if(e.target.matches('[data-fit-chart-units]')) this.convertUnits(e.target.value);
        if(e.target.name === 'remember' && !e.target.checked) this.forget(false);
      });
      this.on(this,'input',e => {e.stopPropagation();if(e.target.type==='range'){this.highlightMeasurement(e.target);this.updateSliders();}});
      this.on(this,'pointerdown',e => this.highlightMeasurement(e.target),{passive:true});
      this.on(this,'touchstart',e => this.highlightMeasurement(e.target),{passive:true});
      this.on(this,'focusin',e => this.highlightMeasurement(e.target));
      this.on(this.form,'submit',e => {
        e.preventDefault();
        e.stopPropagation();
        if(this.step === 0) {
          if(this.form.reportValidity()) this.setStep(1);
        } else {
          this.body = this.readBody();
          this.result = recommend(this.body,this.config);
          this.selected = this.result.chosen;
          this.persist();
          this.renderResult();
          this.setStep(2);
        }
      });
      this.on(this.dialog,'close',() => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        const trigger = document.querySelector('[data-camille-fit="'+this.id+'"]');
        if(trigger) trigger.focus({preventScroll:true});
      });
      this.on(this.dialog,'click',e => {
        if(e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) this.dialog.close();
      });
      this.on(this.querySelector('.mfr-header'),'touchstart',e => {this.touchY=e.changedTouches[0].clientY;},{passive:true});
      this.on(this.querySelector('.mfr-header'),'touchend',e => {
        if(matchMedia('(max-width:749px)').matches && e.changedTouches[0].clientY-this.touchY>70) this.dialog.close();
      },{passive:true});
      this.on(this,'keydown',e => {
        if(!e.target.matches('[data-fit-tab]') || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const name = e.key==='Home'?'finder':e.key==='End'?'chart':this.activeTab==='finder'?'chart':'finder';
        this.showTab(name,false);
        this.querySelector('[data-fit-tab="'+name+'"]').focus();
      });
      this.loadSaved();
      this.updateSliders();
      this.renderTables();
      this.updateProduct();
      this.updateHint();
      const productInfo = this.closest('product-info') || this.parentElement;
      this.observer = new MutationObserver(records => {
        if(records.some(r => !this.contains(r.target) && !r.target.closest?.('.mfr-saved-hint'))) {
          this.updateHint();
          if(this.dialog.open) {this.updateProduct();if(this.result)this.renderResult();}
        }
      });
      this.observer.observe(productInfo,{childList:true,subtree:true});
      this.setStep(this.body?2:0,false);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if(this.dialog?.open) document.documentElement.style.overflow=this.previousOverflow??'';
      this.initialized=false;
    }
    on(target,type,callback,options={}) {target.addEventListener(type,callback,{...options,signal:this.abort.signal});}
    copy(key,values={}) {
      return Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',v),this.text[key]||'');
    }
    picker() {return document.getElementById('product-variant-selects-'+this.dataset.section);}
    selectedOptions() {
      const picker = this.picker();
      if(!picker)return [];
      return Array.from(picker.querySelectorAll('fieldset,.product-form__input--dropdown')).map(group=>group.querySelector('input:checked,select')?.value);
    }
    variant(index=this.selected) {
      const options=this.selectedOptions();
      return this.config.variants.find(v=>v.options.every((value,i)=>i===this.sizeIndex?value===this.sizes[index]:value===options[i]));
    }
    updateProduct() {
      const options=this.selectedOptions();
      const variant=this.config.variants.find(v=>v.options.every((value,i)=>value===options[i]));
      const image=this.querySelector('.mfr-photo');
      if(variant?.image && image) {image.src=variant.image;image.removeAttribute('srcset');}
      this.querySelector('[data-fit-color]').textContent=options[this.colorIndex]||'';
    }
    open() {
      this.updateProduct();
      if(this.result) this.renderResult();
      this.showTab('finder',false);
      this.previousOverflow=document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow='hidden';
      this.focusHeading();
    }
    focusHeading() {
      const panel = this.querySelector('[data-fit-panel="'+this.activeTab+'"]');
      const heading=this.activeTab==='chart'?panel.querySelector('h2'):panel.querySelector('[data-fit-step="'+this.step+'"] h2');
      heading?.focus({preventScroll:true});
      this.querySelector('.mfr-scroll').scrollTop=0;
    }
    setStep(step,focus=true) {
      this.step=step;
      this.querySelector('[data-fit-footer]').hidden=step!==2||this.activeTab!=='finder';
      this.querySelector('[data-fit-flow-footer]').hidden=step===2||this.activeTab!=='finder';
      this.querySelectorAll('[data-fit-flow-step]').forEach(el=>el.hidden=Number(el.dataset.fitFlowStep)!==step);
      this.form.hidden=step===2;
      this.querySelectorAll('[data-fit-step]').forEach(el=>el.hidden=Number(el.dataset.fitStep)!==step);
      this.querySelectorAll('[data-progress]').forEach(el=>{
        el.dataset.active=Number(el.dataset.progress)<=step;
        if(Number(el.dataset.progress)===step)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');
      });
      if(focus)this.focusHeading();
    }
    showTab(name,focus=true) {
      this.activeTab=name;
      this.querySelector('[data-fit-footer]').hidden=this.step!==2||name!=='finder';
      this.querySelector('[data-fit-flow-footer]').hidden=this.step===2||name!=='finder';
      this.querySelectorAll('[data-fit-tab]').forEach(el=>{
        const selected=el.dataset.fitTab===name;
        el.setAttribute('aria-selected',String(selected));el.tabIndex=selected?0:-1;
      });
      this.querySelectorAll('[data-fit-panel]').forEach(el=>el.hidden=el.dataset.fitPanel!==name);
      if(name==='chart')this.renderTables();
      if(focus)this.focusHeading();
    }
    handleClick(e) {
      const button=e.target.closest('button');
      if(!button)return;
      if(button.hasAttribute('data-fit-close'))this.dialog.close();
      if(button.hasAttribute('data-fit-adjust')) {const input=this.form.elements[button.dataset.fitAdjust];if(button.dataset.fitDelta==='1')input.stepUp();else input.stepDown();this.updateSliders();}
      if(button.hasAttribute('data-fit-back'))this.setStep(0);
      if(button.dataset.fitTab)this.showTab(button.dataset.fitTab);
      if(button.hasAttribute('data-fit-chart-link'))this.showTab('chart');
      if(button.hasAttribute('data-fit-return'))this.showTab('finder');
      if(button.hasAttribute('data-fit-edit')) {this.setStep(0);this.showTab('finder');}
      if(button.hasAttribute('data-fit-compare')) {this.selected=Number(button.dataset.fitCompare);this.renderResult();}
      if(button.hasAttribute('data-fit-forget')) {this.forget(true);this.setStep(0);}
      if(button.hasAttribute('data-fit-add'))this.selectSize(true);
    }
    readBody() {
      const f=this.form.elements;
      const factor=this.unit==='cm'?1:2.54;
      return {height:Number(f.height.value)*factor,...Object.fromEntries(measureKeys.map(k=>[k,Number(f[k].value)*factor])),fuller:f.fullerbust.value==='yes',preference:f.preference.value};
    }
    populate(body) {
      const f=this.form.elements;
      ['height',...measureKeys].forEach(k=>f[k].value=Number((body[k]/(this.unit==='cm'?1:2.54)).toFixed(2)));
      f.fullerbust.value=body.fuller?'yes':'no';
      f.preference.value=body.preference||'designed';
      this.updateSliders();
    }
    highlightMeasurement(target) {
      const field=target.closest?.('.mfr-slider-field');
      const input=field?.querySelector('input[type="range"]');
      if(input)this.querySelector('.mfr-figure').dataset.focus=input.name;
    }
    updateSliders() {
      const f=this.form.elements;
      ['height',...measureKeys].forEach(key=>{
        const value=Number(f[key].value);
        let text=String(Number(value.toFixed(1)));
        if(key==='height' && this.unit==='in') {
          const feet=Math.floor(value/12);
          text=feet+'′ '+Number((value-feet*12).toFixed(1))+'″';
        }
        this.querySelector('[data-fit-value="'+key+'"]').textContent=text;
        this.querySelector('[data-fit-value-unit="'+key+'"]').textContent=key==='height'&&this.unit==='in'?'':this.unit;
        f[key].setAttribute('aria-valuetext',text+(key==='height'&&this.unit==='in'?'':' '+this.unit));
        f[key].style.setProperty('--slider-progress',((value-Number(f[key].min))/(Number(f[key].max)-Number(f[key].min))*100)+'%');
        this.querySelectorAll('[data-fit-adjust="'+key+'"]').forEach(button=>button.setAttribute('aria-label',this.copy(button.dataset.fitDelta==='1'?'increase':'decrease',{measurement:this.copy(key)})));
      });
      const estimate=recommend(this.readBody(),this.config);
      this.querySelector('[data-fit-live]').textContent=this.sizes[estimate.chosen];
    }
    convertUnits(next) {
      if(next===this.unit)return;
      const f=this.form.elements;
      const values=Object.fromEntries(['height',...measureKeys].map(k=>[k,Number(f[k].value)*(this.unit==='cm'?1:2.54)]));
      this.unit=next;
      f.units.value=next;
      this.querySelector('[data-fit-chart-units]').value=next;
      ['height',...measureKeys].forEach((k,j)=>{
        f[k].min=Number(([54,26,20,30][j]*(next==='cm'?2.54:1)).toFixed(1));
        f[k].max=Number(([78,54,48,58][j]*(next==='cm'?2.54:1)).toFixed(1));
        f[k].step=next==='cm'?0.1:0.5;
        f[k].value=Number((values[k]/(next==='cm'?1:2.54)).toFixed(2));
      });
      this.updateSliders();
      this.renderTables();
      if(this.result)this.renderResult();
    }
    persist() {
      try {
        if(this.form.elements.remember.checked) {
          localStorage.setItem(storageKey,JSON.stringify({version:1,time:Date.now(),body:this.body,unit:this.unit}));
          this.saved=true;
        } else {localStorage.removeItem(storageKey);this.saved=false;}
      }catch {this.saved=false;}
      this.updateHint();
    }
    loadSaved() {
      try {
        const saved=JSON.parse(localStorage.getItem(storageKey));
        if(!saved)return;
        const b=saved.body;
        if(saved.version!==1 || !Number.isFinite(saved.time) || Date.now()-saved.time>expiry || !b || !['height',...measureKeys].every(k=>Number.isFinite(b[k])&&b[k]>0) || !['close','designed','room'].includes(b.preference)) {localStorage.removeItem(storageKey);return;}
        if(saved.unit==='cm')this.convertUnits('cm');
        this.body=b;this.result=recommend(b,this.config);this.selected=this.result.chosen;this.saved=true;
        this.populate(b);this.renderResult();
      }catch {this.saved=false;}
    }
    forget(reset) {
      try{localStorage.removeItem(storageKey);}catch{}
      this.saved=false;
      this.updateHint();
      if(reset){
        this.body=null;this.result=null;this.unit='in';this.form.reset();
        ['height',...measureKeys].forEach((key,j)=>{const input=this.form.elements[key];input.min=[54,26,20,30][j];input.max=[78,54,48,58][j];input.step=0.5;input.value=input.defaultValue;});
        this.querySelector('[data-fit-chart-units]').value='in';this.updateSliders();this.renderTables();this.form.elements.remember.checked=false;
      }
    }
    updateHint() {
      document.querySelectorAll('.mfr-saved-hint').forEach(hint=>hint.remove());
    }
    format(cm) {return Number((cm/(this.unit==='cm'?1:2.54)).toFixed(1))+' '+this.unit;}
    renderResult() {
      if(!this.result)return;
      const r=this.result,index=this.selected,size=this.sizes[index],recommended=this.sizes[r.chosen];
      this.querySelector('[data-fit-size]').textContent=size;
      this.querySelector('[data-fit-result-label]').textContent=this.copy(index===r.chosen?(r.beyond?'closest':'recommended'):'compare_label');
      const reasons=[];
      if(this.config.camille&&this.body.height>=177.8-0.02)reasons.push(this.copy('tall'));
      if(this.activeKeys.includes('bust')&&this.body.fuller)reasons.push(this.copy('fuller'));
      if(this.body.preference==='room')reasons.push(this.copy('room_reason'));
      if(r.indices[2]>Math.max(r.indices[0],r.indices[1]))reasons.push(this.copy('hip_reason'));
      if(r.beyond)reasons.push(this.copy('max',{largest:this.sizes.at(-1)}));
      if(r.below)reasons.push(this.copy('small',{smallest:this.sizes[0]}));
      this.querySelector('[data-fit-reason]').hidden=!reasons.length;
      this.querySelector('[data-fit-reason]').textContent=reasons.join(' ');
      this.querySelectorAll('[data-fit-compare]').forEach(button=>{
        button.setAttribute('aria-pressed',String(Number(button.dataset.fitCompare)===index));
        button.dataset.recommended=Number(button.dataset.fitCompare)===r.chosen;
      });
      let comparison=index===r.chosen?this.copy('compare'):this.copy('comparing',{size,recommended});
      if(index===r.chosen&&!r.extra&&r.base<this.sizes.length-1&&measureKeys.some((k,j)=>this.activeKeys.includes(k)&&Math.abs(this.bodyChart[r.base][j]-this.body[k]/2.54)<=0.5))comparison=this.copy('between',{size:recommended,next:this.sizes[r.chosen+1]});
      this.querySelector('[data-fit-comparison]').textContent=comparison;
      const breakdown=this.querySelector('[data-fit-breakdown]');
      breakdown.replaceChildren();
      measureKeys.forEach((key,j)=>{
        if(!this.activeKeys.includes(key))return;
        const diff=index-r.indices[j];
        const label=this.copy(diff<0?'tight':diff===0?'ideal':diff===1?'easier':'roomier');
        const row=document.createElement('div');row.className='mfr-fit-row';
        const name=document.createElement('span');name.textContent=this.copy(key);
        const track=document.createElement('span');track.className='mfr-fit-track';track.setAttribute('aria-hidden','true');track.style.setProperty('--fit-position',Math.max(8,Math.min(92,38+diff*24))+'%');track.appendChild(document.createElement('i'));
        const value=document.createElement('span');value.textContent=label;
        row.append(name,track,value);breakdown.appendChild(row);
      });
      const variant=this.variant(index),color=this.selectedOptions()[this.colorIndex]||this.config.productName;
      const stock=this.querySelector('[data-fit-stock]');
      stock.dataset.available=Boolean(variant?.available);
      stock.textContent=variant?this.copy(variant.available?'stock_ok':'unavailable',{size,color}):this.copy('missing');
      this.querySelector('[data-fit-add]').textContent=this.copy('add');
      this.querySelector('[data-fit-add]').disabled=!variant?.available||this.busy;
      this.querySelector('[data-fit-forget]').hidden=!this.saved;
    }
    renderTables() {
      const createTable=(selector,rows)=>{
        const table=this.querySelector(selector);table.replaceChildren();
        const head=table.createTHead().insertRow();
        [this.copy('size'),...this.sizes].forEach((s,i)=>{const th=document.createElement('th');th.scope='col';th.textContent=s;if(i&&this.result?.chosen===i-1)th.className='mfr-chart-selected';head.appendChild(th);});
        const tbody=table.createTBody();
        rows.forEach(([key,values])=>{const row=tbody.insertRow();const name=document.createElement('th');name.scope='row';name.textContent=this.copy(key);row.appendChild(name);values.forEach((v,i)=>{const cell=row.insertCell();cell.textContent=Number((v/(this.unit==='cm'?1:2.54)).toFixed(1));if(this.result?.chosen===i)cell.className='mfr-chart-selected';});});
      };
      createTable('[data-fit-body-table]',measureKeys.flatMap((key,j)=>this.activeKeys.includes(key)?[[key,this.bodyChart.map(row=>row[j]*2.54)]]:[]));
    }
    async selectSize(add) {
      if(this.busy)return;
      const variant=this.variant(),size=this.sizes[this.selected];
      if(!variant || (add&&!variant.available))return;
      const picker=this.picker();
      if(!picker)return;
      this.busy=true;this.renderResult();
      const error=this.querySelector('[data-fit-error]');error.hidden=true;
      const formId='product-form-'+this.dataset.section;
      const group=Array.from(picker.querySelectorAll('fieldset,.product-form__input--dropdown'))[this.sizeIndex];
      const radio=Array.from(group?.querySelectorAll('input[type=radio]')||[]).find(input=>input.value===size);
      const select=group?.querySelector('select');
      try {
        if(!radio&&!select)throw Error('picker');
        const ready=new Promise((resolve,reject)=>{
          const check=()=>document.getElementById(formId)?.querySelector('[name=id]')?.value===String(variant.id);
          if(check()){resolve();return;}
          const observer=new MutationObserver(()=>{if(check()){observer.disconnect();clearTimeout(timer);resolve();}});
          const timer=setTimeout(()=>{observer.disconnect();reject(Error('selection'));},8000);
          observer.observe(this.closest('product-info')||document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
        });
        if(radio&&!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
        if(select&&select.value!==size){select.value=size;select.dispatchEvent(new Event('change',{bubbles:true}));}
        await ready;
        const form=document.getElementById(formId);
        const currentId=form?.querySelector('[name=id]');
        if(!form || currentId?.value!==String(variant.id))throw Error('variant');
        this.dialog.close();
        if(add){const submit=form.querySelector('[type=submit]')||document.querySelector('[form="'+formId+'"][type=submit]');if(!submit||submit.disabled)throw Error('submit');form.requestSubmit(submit);}
      } catch {
        if(!this.dialog.open)this.open();
        error.textContent=this.copy('error');error.hidden=false;error.scrollIntoView({block:'nearest'});
      } finally {this.busy=false;this.renderResult();}
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product__tab-item"] && !Shopify.designMode) return;
  try {
    function normalizeProductDetailsSpacing(root) {
    root.querySelectorAll('.product__tab-content--description p').forEach((paragraph) => {
      if (
        paragraph.textContent.trim() === '' &&
        !paragraph.querySelector('img, picture, video, audio, iframe, svg, canvas, input, button, object, embed')
      ) {
        paragraph.remove();
      } else if (
        /^(description|details|materials\s*(?:&|and)\s*care|fit notes|sustainability|size\s*&\s*fit)\s*:?\s*$/i.test(paragraph.textContent.trim()) &&
        !paragraph.querySelector('strong, b')
      ) {
        const heading = document.createElement('strong');
        while (paragraph.firstChild) {
          heading.appendChild(paragraph.firstChild);
        }
        paragraph.appendChild(heading);
      }
    });
  }

  normalizeProductDetailsSpacing(document);
  document.addEventListener('shopify:section:load', (event) => {
    normalizeProductDetailsSpacing(event.target);
  });

  function initializeProductTabExcerpts(root) {
    root.querySelectorAll('.product__tab-content').forEach((panel) => {
      const body = panel.querySelector('.product-tab-excerpt__body');
      const text = panel.querySelector('.product-tab-excerpt__text');
      const toggle = panel.querySelector('.product-tab-excerpt__toggle');
      if (!body || !text || !toggle || panel.dataset.excerptInitialized) return;
      panel.dataset.excerptInitialized = 'true';

      function setExpanded(expanded) {
        panel.classList.toggle('product-tab-excerpt--collapsed', !expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
      }

      let expanded = false;
      function update() {
        if (!panel.getClientRects().length || !text.offsetWidth) return;
        const needsToggle = text.scrollHeight > 260;
        toggle.hidden = !needsToggle;
        if (!needsToggle) {
          panel.classList.remove('product-tab-excerpt--collapsed');
        } else {
          setExpanded(expanded);
        }
      }

      toggle.addEventListener('click', () => {
        expanded = !expanded;
        setExpanded(expanded);
      });
      text.addEventListener('focusin', () => {
        if (!toggle.hidden && !expanded) {
          expanded = true;
          setExpanded(true);
        }
      });
      new ResizeObserver(update).observe(text);
      update();
    });
  }

  initializeProductTabExcerpts(document);
  document.addEventListener('shopify:section:load', (event) => {
    initializeProductTabExcerpts(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mpaz-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mpaz-cart-upsell')) {
    class MpazCartUpsell extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.list = this.querySelector('ul');
        this.addEventListener('click', event => this.onClick(event), { signal });
        this.list.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.list);
        this.drawer = this.closest('cart-drawer');
        if (this.drawer && !this.drawer.classList.contains('is-visible')) {
          this.observer = new MutationObserver(() => {
            if (this.drawer.classList.contains('is-visible')) {
              this.observer.disconnect();
              this.load();
            }
          });
          this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        } else this.load();
      }
      disconnectedCallback() {
        this.controller.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
      updateNavigation() {
        const offset = Math.abs(this.list.scrollLeft);
        this.querySelector('[data-slide="-1"]').disabled = offset < 2;
        this.querySelector('[data-slide="1"]').disabled = offset >= this.list.scrollWidth - this.list.clientWidth - 2;
      }
      onClick(event) {
        const slide = event.target.closest('[data-slide]');
        if (slide) {
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.list.scrollBy({ left: Number(slide.dataset.slide) * direction * this.list.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
      async load() {
        const ids = this.dataset.productIds.split(',');
        const excluded = new Set(ids);
        const chosen = new Map();
        try {
          for (const id of ids.slice(0, 3)) {
            const url = new URL(this.dataset.url, location.origin);
            url.search = new URLSearchParams({ section_id: 'mpaz-cart-upsell', product_id: id, limit: '10', intent: 'complementary' });
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) continue;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            this.collect(html.querySelectorAll('[data-upsell-product]'), excluded, chosen);
            if (chosen.size >= 6) break;
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
        if (!this.isConnected) return;
        this.collect(this.querySelector('[data-fallback]').content.querySelectorAll('[data-upsell-product]'), excluded, chosen);
        this.list.replaceChildren(...chosen.values());
        this.hidden = chosen.size === 0;
        this.updateNavigation();
      }
      collect(cards, excluded, chosen) {
        for (const card of cards) {
          const id = card.dataset.upsellProduct;
          if (!excluded.has(id) && !chosen.has(id) && chosen.size < 6) chosen.set(id, card.cloneNode(true));
        }
      }
    }
    customElements.define('mpaz-cart-upsell', MpazCartUpsell);
  }
  } catch(e) { console.error(e); }
})();

})();
